import {
  createSetBlankContactDataAction,
  createSetContactDataAction
} from "../actions/dataActions";
import { useHttpGetAndSet } from "./useHttpGetAndSet";

export const useContactData = (id, dataFresh, contact_type) => {
  const nofetch = !id;
  const [loading, error] = useHttpGetAndSet(
    `contacts/${id}`,
    "get",
    {},
    dataFresh,
    nofetch,
    createSetBlankContactDataAction,
    {
      contact_type: contact_type || "CC",
      labour_rate: 40,
      labour_rate_markup: 0,
      additional_contacts: [],
      part_contacts: [],
      workshop_contacts: [],
      workshop_instructions: [],
      rental_instructions: [],
      partial_contact: true,
      payment_term_days: 0,
      workshop_account_code: "02",
      deposit_account_code: "03",
      hire_account_code: "01",
      part_account_code: "05",
      movement_account_code: "08",
      company_phone_type: "Phone",
      cash_sales: []
    }
  );
  if (error) {
    throw Error("There was an error");
  }

  return !loading;
};
